<sirius-container>
    @if (resolvedTitle() || resolvedTextHtml()) {
        <sirius-card-collection-text
            [title]="resolvedTitle()"
            [text]="resolvedTextHtml()"></sirius-card-collection-text>
    }

    <div class="sir-card-flip-grid-list" role="list" data-cy="card-flip-grid-list">
        @for (item of visibleItems(); track trackItem(item, $index)) {
            <div class="sir-card-flip-grid-item" role="listitem" data-cy="card-flip">
                <sirius-card-flip
                    [config]="item"
                    [imageData]="imageData()"
                    (selectEvent)="onCardSelect(item, $index)"></sirius-card-flip>
            </div>
        }
    </div>
</sirius-container>
